import { connect } from 'react-redux'
import { getPlot } from '../selectors'
import { getSelectionByKey } from '../../selection/selectors'
import { setBudgetBlock } from '../../budget/actions'
import { togglePlot } from '../../selection/actions'
import Plot from '../components/plot'

const mapStateToProps = state => ({
  plot: getPlot(state),
  selection: getSelectionByKey({
    state,
    key: 'plot',
  }),
})

const mapDispatchToProps = dispatch => ({
  setBudgetBlock: (payload) => {
    dispatch(setBudgetBlock(payload))
  },
  togglePlot: (payload) => {
    dispatch(togglePlot(payload))
  },
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Plot)



// WEBPACK FOOTER //
// ./src/modules/plot/containers/plot.js